export function exportExcel(blobData, name) {
    const link = document.createElement("a"); //创建a标签
    const blob = new Blob([blobData], {
      type: "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet",
    }); //设置文件流
    link.style.display = "none";
  
    // 设置连接
    link.href = URL.createObjectURL(blob); //将文件流转化为blob地址
    link.download = `${name}-${getCurrentTime()}`;
    document.body.appendChild(link);
    // 模拟点击事件
    link.click(); //设置点击事件
    link.remove();
  }
  
  function getCurrentTime() {
    var date = new Date(); //当前时间
    var year = date.getFullYear(); //年
    var month = repair(date.getMonth() + 1); //月
    var day = repair(date.getDate()); //日
    var hour = repair(date.getHours()); //时
    var minute = repair(date.getMinutes()); //分
    var second = repair(date.getSeconds()); //秒
  
    //当前时间
    var curTime =
      year + "-" + month + "-" + day + "-" + hour + "-" + minute + "-" + second;
    return curTime;
  }
  
  //若是小于10就加个0
  function repair(i) {
    if (i >= 0 && i <= 9) {
      return "0" + i;
    } else {
      return i;
    }
  }
  